// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unclickable_btns {
  height: 15.66vh;
  background-color: white;
  border-radius: 46.875rem;
  width: -moz-fit-content;
  width: fit-content;
}
.unclickable_btnsheading {
  color: #000;
  font-size: 1.875rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 3px;
  text-transform: uppercase;
  padding-bottom: 0.4375rem;
}
.unclickable_btnSubheading {
  font-size: 1.078125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.unclickable_.childDivText4 {
  width: 30vw !important;
}
.unclickable_textdiv {
  display: flex;
  flex-direction: column;
  padding-left: 1.3125rem;
}
.unclickable_div {
  align-self: center;
  display: flex;
  padding: 24px;
}

.unclickable_btnimg {
  width: 4.5vw !important;
}

@media (max-width: 768px) {
  .unclickable_btnimg {
    width: 100% !important;
  }
  .unclickable_btnimg {
    width: 8.5vw !important;
  }
  .unclickable_btnSubheading {
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
  }
}
@media only screen and (min-width: 320px) and (max-width: 576px) {
  .unclickable_btns {
    height: 120px;
    background-color: white;
    border-radius: 46.875rem;
    width: 100vw;
  }
  .unclickable_div {
    align-self: center;
    display: flex;
    padding: 20px;
  }
  .unclickable_btnsheading {
    color: #000;
    font-size: 1.875rem;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 3px;
    text-transform: uppercase;
    padding-bottom: 0.4375rem;
  }
  .unclickable_btnSubheading {
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .unclickable_btnimg {
    width: 21.5vw !important;
  }
}
.btnsheadingNew {
  color: #000;
  text-align: left;
  width: 100%;
  font-size: 1.5vw;
  font-weight: bold;
  margin-bottom: 0rem;
}

.btnSubheadingNew {
  color: #000;
  width: 100%;
  font-size: 1.05vw;
  margin-bottom: 0rem;
  text-align: left;
}

.unclickable_col {
  height: 5.5vw;
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  z-index: 2;
}

.unclickable-img {
  width: 4vw !important;
}

@media (max-width: 1200px) {
  .unclickable_col {
    height: 8vw;
  }
  .unclickable-img {
    width: 6vw !important;
  }
  .btnsheadingNew {
    font-size: 2.5vw;
  }
  .btnSubheadingNew {
    font-size: 16px;
    width: 22vw;
  }
}
@media (max-width: 768px) {
  .unclickable_col {
    padding: 1vh;
    height: 20vw;
  }
  .unclickable-img {
    width: 15vw !important;
    padding: 1vh;
  }
  .btnsheadingNew {
    font-size: 4.5vw;
    margin-bottom: 1vw;
  }
  .btnSubheadingNew {
    font-size: 4vw;
    width: 36vw;
  }
}
@media (max-width: 576px) {
  .btnsheadingNew {
    font-size: 6vw;
  }
  .btnSubheadingNew {
    font-size: 4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/UnclickableButton/unclickableButton.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EAAA,kBAAA;AAAJ;AAGE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AADJ;AAIE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAIE;EACA,sBAAA;AAFF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;AAHJ;;AAMA;EACE,uBAAA;AAHF;;AAKA;EACE;IACE,sBAAA;EAFF;EAIA;IACE,uBAAA;EAFF;EAIA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EAFF;AACF;AAIA;EACE;IACE,aAAA;IACA,uBAAA;IACA,wBAAA;IACA,YAAA;EAFF;EAKA;IACE,kBAAA;IACA,aAAA;IACA,aAAA;EAHF;EAMA;IACE,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;IACA,yBAAA;IACA,yBAAA;EAJF;EAOA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EALF;EAOA;IACE,wBAAA;EALF;AACF;AAQA;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AANF;;AASA;EACE,WAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AANF;;AASA;EACE,qBAAA;AANF;;AASA;EACE;IAEE,WAAA;EAPF;EAUA;IACE,qBAAA;EARF;EAWA;IACE,gBAAA;EATF;EAYA;IACE,eAAA;IACA,WAAA;EAVF;AACF;AAaA;EACE;IACE,YAAA;IACA,YAAA;EAXF;EAcA;IACE,sBAAA;IACA,YAAA;EAZF;EAeA;IACE,gBAAA;IACA,kBAAA;EAbF;EAgBA;IACE,cAAA;IACA,WAAA;EAdF;AACF;AAiBA;EACE;IACE,cAAA;EAfF;EAkBA;IACE,cAAA;EAhBF;AACF","sourcesContent":[".unclickable {\n  &_btns {\n    height: 15.66vh;\n    background-color: white;\n    border-radius: 46.875rem;\n    width: fit-content;\n  }\n\n  &_btnsheading {\n    color: #000;\n    font-size: 1.875rem;\n    font-style: normal;\n    font-weight: 900;\n    line-height: normal;\n    letter-spacing: 3px;\n    text-transform: uppercase;\n    padding-bottom: 0.4375rem;\n  }\n\n  &_btnSubheading {\n    font-size: 1.078125rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  &_.childDivText4{\n  width:30vw !important;\n}\n  &_textdiv {\n    display: flex;\n    flex-direction: column;\n    padding-left: 1.3125rem;\n  }\n\n  &_div {\n    align-self: center;\n    display: flex;\n    padding: 24px;\n  }\n}\n.unclickable_btnimg {\n  width: 4.5vw !important;\n}\n@media (max-width: 768px) {\n  .unclickable_btnimg {\n    width: 100% !important;\n  }\n  .unclickable_btnimg {\n    width: 8.5vw !important;\n  }\n  .unclickable_btnSubheading {\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 19px;\n  }\n}\n@media only screen and (min-width: 320px) and (max-width: 576px) {\n  .unclickable_btns {\n    height: 120px;\n    background-color: white;\n    border-radius: 46.875rem;\n    width: 100vw;\n  }\n\n  .unclickable_div {\n    align-self: center;\n    display: flex;\n    padding: 20px;\n  }\n\n  .unclickable_btnsheading {\n    color: #000;\n    font-size: 1.875rem;\n    font-style: normal;\n    font-weight: 900;\n    line-height: normal;\n    letter-spacing: 3px;\n    text-transform: uppercase;\n    padding-bottom: 0.4375rem;\n  }\n\n  .unclickable_btnSubheading {\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .unclickable_btnimg {\n    width: 21.5vw !important;\n  }\n}\n\n.btnsheadingNew {\n  color: #000;\n  text-align: left;\n  width: 100%;\n  font-size: 1.5vw;\n  font-weight: bold;\n  margin-bottom: 0rem;\n}\n\n.btnSubheadingNew {\n  color: #000;\n  width: 100%;\n  font-size: 1.05vw;\n  margin-bottom: 0rem;\n  text-align: left;\n}\n\n.unclickable_col {\n  height: 5.5vw;\n  width: 100%;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  z-index: 2;\n}\n\n.unclickable-img {\n  width: 4vw !important;\n}\n\n@media (max-width: 1200px) {\n  .unclickable_col {\n    // padding: 1vh;\n    height: 8vw;\n  }\n\n  .unclickable-img {\n    width: 6vw !important;\n  }\n\n  .btnsheadingNew {\n    font-size: 2.5vw;\n  }\n\n  .btnSubheadingNew {\n    font-size: 16px;\n    width:22vw;\n  }\n}\n\n@media (max-width: 768px) {\n  .unclickable_col {\n    padding: 1vh;\n    height: 20vw;\n  }\n\n  .unclickable-img {\n    width: 15vw !important;\n    padding: 1vh;\n  }\n\n  .btnsheadingNew {\n    font-size: 4.5vw;\n    margin-bottom: 1vw;\n  }\n\n  .btnSubheadingNew {\n    font-size: 4vw;\n    width: 36vw;\n  }\n}\n\n@media (max-width: 576px) {\n  .btnsheadingNew {\n    font-size: 6vw;\n  }\n\n  .btnSubheadingNew {\n    font-size: 4vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
